/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_sini } from "../../App/actions/sini_v2";

/*PICTURE*/
import icon_expand_bottom from "../../Assets/svg/icon_expand_bottom.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

//*CONST*/

class SINI_RDTR extends Component {
  state = {};

  componentDidMount() {
    const { sini_v2_list, request_id_active, ai_parent_detail_list } =
      this.props.sini;
    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    const sini_object = merge_array.find(
      (item) => item.request_id === request_id_active
    );
    const rdtr_one = sini_object?.rdtr_one;
    if (rdtr_one !== undefined) {
      this.add_slide_in_class();
    }
  }

  componentDidUpdate(prevProps) {
    const loading_item_array_before =
      prevProps.loading_reducer.loading_item_array;
    const loading_item_array_after =
      this.props.loading_reducer.loading_item_array;
    const last_loading =
      loading_item_array_after[loading_item_array_after.length - 1];
    if (
      loading_item_array_after.length !== loading_item_array_before.length &&
      (last_loading === "rdtr" || last_loading === "get_ai_parent_object")
    ) {
      this.add_slide_in_class();
    }
  }

  add_slide_in_class = () => {
    const element = document.querySelector("#rdtr_parent");
    if (element) {
      element.classList.add("slide-in");
    }
  };

  on_set_sini_menu_active = () => {
    this.props.set_value_sini({
      key: "sini_menu_active",
      value: "rdtr",
    });
    this.props.set_value_sini({
      key: "sini_map_show",
      value: ["rdtr_one", "rdtr_neighbor"],
    });
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props
    const { sini_v2_list, request_id_active, ai_parent_detail_list } =
      this.props.sini;
    const { loading_item_array } = this.props.loading_reducer;

    //content
    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    const is_loading_rdtr = loading_item_array.includes("rdtr");

    const sini_object = merge_array.find(
      (item) => item.request_id === request_id_active
    );
    const rdtr_one = sini_object?.rdtr_one;

    let content;

    if (is_loading_rdtr || rdtr_one !== undefined) {
      const rdtr_value = rdtr_one?.properties?.["NAMZON_1"];

      const is_rdtr_empty = rdtr_value === undefined;

      let rdtr_content;
      if (is_loading_rdtr) {
        rdtr_content = (
          <>
            <p className="text_medium sub_color">
              {dict?.["Loading data"]?.[language]}...
            </p>
            <br />
          </>
        );
      } else if (!is_rdtr_empty) {
        rdtr_content = (
          <section className="margin_bottom">
            <span className="text_bold margin_right">{rdtr_value}</span>
            <span className="text_medium sub_color">
              {dict?.["(RDTR zone name)"]?.[language]}
            </span>
          </section>
        );
      } else {
        rdtr_content = (
          <section className="margin_bottom">
            <p className="text_medium sub_color">
              {dict?.["No data"]?.[language]}
            </p>
          </section>
        );
      }

      content = (
        <main className="container_light background_white margin_bottom outline_grey">
          <div
            className="badge background_grey_light margin_bottom"
            onClick={this.on_set_sini_menu_active}
          >
            {dict?.["Kalkulator RDTR"]?.[language]}
          </div>
          <br />
          {rdtr_content}
          <div className="text_center">
            <img
              onClick={this.on_set_sini_menu_active}
              alt="expand"
              src={icon_expand_bottom}
              width={45}
              className="cursor_pointer"
            />
          </div>
        </main>
      );
    }

    return <main id="rdtr_parent">{content}</main>;
  }
}

const mapStateToProps = (state) => ({
  sini: state.sini,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, { set_value_sini })(SINI_RDTR);
